import axios from 'axios'

const LoggingPlugin = {
  install(Vue) {
    // 1. add global method or property
    Vue.prototype.$createLog = function(l, p, n, name) {
      const logObject = {
        field: l,
        prev: p,
        next: n,
        method: 'Select',
        amount: 1,
        ...{name},
      }
      axios.post(this.apiActions.loggingUrl, logObject)
    }
    Vue.prototype.$sendLog = function(logObject) {
      axios.post(this.apiActions.loggingUrl, logObject)
    }
  },
}

export default LoggingPlugin
